import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule,} from '@angular/common/http';
import {DatePipe, registerLocaleData} from '@angular/common';
import localeAr from '@angular/common/locales/ar';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {SharedModule} from './shared/shared.module';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BasicLayoutComponent} from './layout/basic/basic-layout.component';
import {JwtInterceptor} from './core/service/jwt.interceptor';
import {ErrorInterceptor} from './core/service/error.interceptor';
import {AdminLayoutComponent} from './layout/admin-layout/admin-layout.component';
import {SideBarComponent} from './layout/admin-layout/sidebar/sidebar.component';
import {HeaderComponent} from './layout/admin-layout/header/header.component';
import {ToastrModule} from 'ngx-toastr';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FooterComponent} from './layout/admin-layout/footer/footer.component';
import {NotificationsModule} from './features/notifications/notifications.module';

registerLocaleData(localeAr);

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

registerLocaleData(localeAr);

@NgModule({
  declarations: [
    AppComponent,
    BasicLayoutComponent,
    AdminLayoutComponent,
    SideBarComponent,
    HeaderComponent,
    FooterComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NotificationsModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      iconClasses: {
        error: 'toast-error',
        info: 'toast-info',
        success: 'toast-success',
        warning: 'toast-warning',
      },
    }),
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgbModule,
  ],
  exports: [TranslateModule],
  providers: [
    DatePipe,
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    {provide: LOCALE_ID, useValue: localStorage.getItem('language') || 'en'},
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
